var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,{tag:"component",attrs:{"$v":_vm.$v,"addressValidator":_vm.addressValidator,"ficheValidator":_vm.ficheValidator,"isVIEWER":_vm.isVIEWER,"isAnArtisan":_vm.isAnArtisan}})}
var staticRenderFns = []

export { render, staticRenderFns }